import React from "react"
import * as styles from "../../styles/accesscard.module.scss"

const AccessCard = ({ mapUrl, parking, roadInfos, point, naviUrl }) => {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.flexWrapper}>
        {/* 左側：Googleマップ */}
        <div className={styles.mapSide}>
          <iframe
            src={mapUrl}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Access Map"
          ></iframe>
        </div>

        {/* 右側：スペック情報 */}
        <div className={styles.infoSide}>
          {/* 駐輪場セクション */}
          <div className={styles.section}>
            <span className={styles.label}>駐輪場</span>
            <div className={styles.parkingBox}>
              <span
                className={`${styles.badge} ${
                  parking.isPaved ? styles.paved : styles.unpaved
                }`}
              >
                {parking.isPaved ? "舗装あり" : "砂利/未舗装"}
              </span>
              <p className={styles.text}>{parking.comment}</p>
            </div>
          </div>

          {/* 道路情報セクション */}
          {roadInfos && roadInfos.length > 0 && (
            <div className={styles.section}>
              <span className={styles.label}>道路情報</span>
              <ul className={styles.roadList}>
                {roadInfos.map((info, index) => (
                  <li key={index} className={styles.text}>
                    {info}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* ライダーズ・ポイント */}
          {point && (
            <div className={styles.pointSection}>
              <span className={styles.pointTitle}>＼ Rider's Point ／</span>
              <p className={styles.pointText}>{point}</p>
            </div>
          )}
        </div>
      </div>

      {/* ナビボタン */}
      {naviUrl && (
        <a
          href={naviUrl}
          target="_blank"
          rel="noreferrer"
          className={styles.naviButton}
        >
          Googleマップでナビを開始
        </a>
      )}
    </div>
  )
}

export default AccessCard
